<hlm-toaster richColors />
<router-outlet></router-outlet>
